<div class="dsd-m-sm">
  <p class="dsd-t-6 dsd-fw-bold">Capacité financière</p>
  <dsd-select
    class="dsd-mb-sm"
    name="statut"
    [value]="statutCapacite$ | async"
    (dsdSelectChange)="changeStatut($event.detail.value)"
    hide-required-labelling
    no-default-option
  >
    <span slot="label">Statut</span>
    <span slot="options">
      <option *ngFor="let status of statusCapaciteValues" [value]="status">{{ status }}</option>
    </span>
  </dsd-select>
  <br />
  <dsd-select
    class="dsd-mb-sm"
    name="page"
    hide-required-labelling
    (dsdSelectChange)="changeCurrentStep($event.detail.value)"
  >
    <span slot="label">Aller à une étape</span>
    <span slot="options">
      <option *ngFor="let step of stepValues" [value]="CapaciteStepEnum[step]">{{ step }}</option>
    </span>
  </dsd-select>
</div>
